import Vue from "vue";
import ElementUI from "element-ui";
import * as api from "@/api";
import VueMoment from "@/packages/vue-moment";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "@/api/axiosInterceptors";
import "@/assets/style/base.css";
import "@/assets/style/element-ui.scss";
import "animate.css";
import "@/icons";

// 处理字符串过长的过滤{{item.name | convertStr(10)}}
Vue.filter("convertStr", (str: string, count: number) => {
    let val = str.replace(/\s+/g, "");
    if (val.length > count) {
        val = `${val.substring(0, count)}...`;
    }
    return val;
});

Vue.use(VueMoment);
Vue.use(ElementUI);
Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
    const option = {
        page: to.path,
        pageName: "",
        clientType: 0
    };
    if (to.name === "Home" && window.innerWidth <= 1120) {
        // 屏幕过小直接跳转首页
        router.replace({ path: "/products" });
    }
    if (to.path === "/related/products") {
        /**
         * TODO:
         * 页面刷新时,from.path会变成'/';
         * 这里的判断有点问题
         */
        if (from.name === "ProductDetail" || from.path === "/") {
            next();
        }
    } else {
        if (to.name === "ProductDetail") {
            option.pageName = "ProductDetail";
        } else if (to.name === "Home") {
            option.pageName = "Home";
        } else if (to.name === "ProductList") {
            option.pageName = "ProductList";
        } else {
            option.pageName = "";
        }
        next();
    }
    api.postPageVisits(option);
});

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#app");
